import { render, staticRenderFns } from "./招商项目.vue?vue&type=template&id=090b2102&scoped=true"
import script from "./招商项目.vue?vue&type=script&lang=js"
export * from "./招商项目.vue?vue&type=script&lang=js"
import style0 from "./招商项目.vue?vue&type=style&index=0&id=090b2102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b2102",
  null
  
)

export default component.exports